import React from "react";

const STATS = [
  { value: "85%", label: "First-year client retention target" },
  { value: "6", label: "Parishes in our 3-year roadmap" },
  { value: "90", label: "Days of post-arrival check-ins (Elite)" },
  { value: "100%", label: "Background-checked staff" },
];

export default function StatsBand() {
  return (
    <section
      data-testid="stats-band"
      className="relative py-20 md:py-28"
      style={{
        background:
          "linear-gradient(135deg, #4A7C82 0%, #3B6368 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 text-white">
            <span className="text-[11px] tracking-[0.28em] uppercase text-white/70">
              Our 3-Year Promise
            </span>
            <h2 className="font-serif text-4xl md:text-5xl mt-5 leading-[1.05] text-balance">
              Quietly building the gold standard for senior lifestyle
              management in Jamaica.
            </h2>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-8">
            {STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.value}`}
                className="border-l-2 border-white/30 pl-6"
              >
                <div className="font-serif text-5xl md:text-6xl text-white">
                  {s.value}
                </div>
                <div className="text-sm text-white/75 mt-3 leading-relaxed">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
